<ui-section class="items-start">
  <ui-block width="3x">
    <h3>EzForm Progress Dialog Sample</h3>
    <ui-form
      [config]="sampleFormConfig"
      containerClass="justify-start compact"
      [(formValues)]="sampleFormValuesSig"
      (buttonClick)="onSampleButtonClick($event)"
    />
  </ui-block>

  <ui-block width="2x">
    <div>
      <h4 class="font-semiboldX mb-2X">Last completion:</h4>
      @if (lastCompletion(); as completion) {
        <pre>{{ completion | json }}</pre>
      } @else {
        <div>None yet.</div>
      }
    </div>
  </ui-block>
</ui-section>
